import { handlerGenericStepWorkflow } from './helpers/workflow';
import { WorkflowService } from './api/WorkflowService';

export const assignOwnerHandler = async ({
  record,
  workflowInstance,
  userEmail,
  referenceValue,
  referenceName,
  checklistItem,
  checklistData,
  more,
  onSuccess,
  onError,
  onFinally,
}: any) => {
  const itemToUse = checklistItem ? checklistItem : checklistData;

  const payloadForUpdateWorkflowinstanceAttribute = {
    item: itemToUse,
    record: {
      ...record,
      ...workflowInstance,
    },
    value: more?.selectedUser,
    attribute_name: 'ownedBy',
  };

  try {
    let response;
    try {
      response = await WorkflowService.updateRecordByAttribute(
        payloadForUpdateWorkflowinstanceAttribute
      );
    } catch (attrError) {
      console.warn('updateRecordByAttribute failed, falling back to workflowInstance', attrError);
      response = {
        ...workflowInstance,
        ownedBy: more?.selectedUser,
      };
    }

    const modifiedFields = {
      assigned: more?.selectedUser,
    };

    const payloadForUpdateWorkflowinstance = {
      referenceValue,
      referenceName,
      ownedBy: more?.selectedUser,
    };

    await handlerGenericStepWorkflow(
      response,
      record,
      payloadForUpdateWorkflowinstance,
      itemToUse,
      userEmail,
      modifiedFields
    );

    if (onSuccess) await onSuccess();
  } catch (err) {
    if (onError) onError(err);
  } finally {
    if (onFinally) await onFinally();
  }
};